import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const defaultState = fromJS({
    msg: 'UserInfo',
})



export default (state = defaultState, action) => {

    switch (action.type) {


        case actionTypes.SET_VIDEO_PLAY_DATA:
            return state.set("videoPlay",action.data)

        default:
            return state;
    }
}
